export default {
    getCurrentPage: (state) => state.registration.currentPage,
    isModalOpen: (state) => state.registration.modalOpen,
    isDesktop: (state) => state.registration.isDesktop,
    getEmailData: (state) => state.registration.emailData,
    getFirstNameData: (state) => state.registration.firstNameData,
    getSurnameData: (state) => state.registration.surnameData,
    getBirthdayData: (state) => state.registration.birthdayData,
    getPromocodeData: (state) => state.registration.promocodeData,
    isPromocodeInQueryString: (state) => state.registration.isPromocodeInQueryString,
    getIsLoadingStep1: (state) => state.registration.isLoadingStep1,
    getIsLoadingStep2: (state) => state.registration.isLoadingStep2,
    getIsLoadingStates: (state) => state.registration.isLoadingStates,
    getUsernameData: (state) => state.registration.usernameData,
    getPasswordData: (state) => state.registration.passwordData,
    getStatesData: (state) => state.registration.statesData,
    getPhoneData: (state) => state.registration.phoneData,
    getIsLoadingStepSms: (state) => state.registration.isLoadingStepSms,
    resendAvailable: (state) => state.registration.resendAvailable,
    getOtpMessage: (state) => state.registration.otpMessage,
    getOtpCountDownMessage: (state) => state.registration.otpCountDownMessage,
    getOtpError: (state) => state.registration.otpError,
    showOtpRemainingTime: (state) => state.registration.showOtpRemainingTime,
    getPendingRegistrationId: (state) => state.registration.pendingRegistrationId,
    getCreateAccountMessageError: (state) => state.registration.createAccountMessageError,
    getBtagValue: (state) => state.registration.btagValue,
    createAccountSuccess: (state) => state.registration.createAccountSuccess,
    getOtpExpiredAttempts: (state) => state.registration.otpExpiredAttempts,
    getOtpExpiredTime: (state) => state.registration.otpExpiredTime,
    getClientId: (state) => state.registration.clientId,
    getGtmRegistrationStartSent: (state) => state.registration.gtmRegistrationStartSent,
    getGtmRegistrationFirstInteractionSent: (state) => state.registration.gtmRegistrationFirstInteractionSent,
    getGtmRegistrationSuccessSent: (state) => state.registration.gtmRegistrationSuccessSent,
};
